const DIALOG_ROLES = ["dialog", "alertdialog"];

const forEachDialogRole = (qualifier: string) =>
  DIALOG_ROLES.map((role) => `[role="${role}"]${qualifier}`).join(", ");

export const DIALOG_SELECTOR = forEachDialogRole("");
export const OPEN_DIALOG_SELECTOR = forEachDialogRole('[data-state="open"]');
export const CLOSING_DIALOG_SELECTOR = forEachDialogRole(
  '[data-state="closed"]',
);
